import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAuth } from "../../../hooks/useAuth";
import { useCampaignPerformanceQuery } from "../../../hooks/useCampaignPerformanceQuery";
import { useAirlinesCampaignPerformanceQuery } from "../../../hooks/useAirlinesCampaignPerformanceQuery";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { ChartNoData } from "../ChartNoData";
import { DiscountedBookingsChart } from "./DiscountedBookingsChart";
import { useMemo } from "react";

export type SingleSeriesDiscountedBookingsLoaderProps = {
  from: Date;
  to: Date;
};

export const SingleSeriesDiscountedBookingsLoader = ({ from, to }: SingleSeriesDiscountedBookingsLoaderProps) => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();
  const useQuery = isAirlineUser ? useCampaignPerformanceQuery : useAirlinesCampaignPerformanceQuery;
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const { data: metrics } = useQuery({
    from,
    to,
    metrics: ["DISCOUNTED_BOOKINGS_SOLD"],
    airlineCode: selectedAirline?.code,
  });

  const series = useMemo(() => {
    const discountedBookingsMetric = metrics.find(
      (metric) => metric.metadata.metricName === "DISCOUNTED_BOOKINGS_SOLD"
    );
    if (!discountedBookingsMetric) {
      return [];
    }

    return [
      {
        airlineCode: selectedAirline?.code ?? "",
        airlineName: selectedAirline?.name ?? "",
        metric: discountedBookingsMetric,
      },
    ];
  }, [selectedAirline, metrics]);

  if (!series.length) {
    return <ChartNoData titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))} />;
  }

  return <DiscountedBookingsChart series={series} />;
};
